/** @module Merchandising/_VersionsMixin */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"underscore",
	"csi",
	"csi/xml"
], function(declare, lang, _, csi, xml) {

	return declare(null, {
		existingProducts: null,

		/**
		 * Aggregate version nodes. Make sure only one version can be selected from a product.
		 *  @param {FormData} fd
		 */
		onFormData(fd) {
			fd.m_fAggregateTest = lang.hitch(this, this._canAggregate);
			fd.useParentNameInSelectionOverview = true;
			fd.addSelectListener((ctx, url, bOn, bReplaced) => {
				if (bOn) {
					const product = ctx.getNodeParent();
					const context = ctx.copyContext();

					product.Versions.forEach((versionURL) => {
						if (url != versionURL) {
							fd.changeSelection(context.setNodeURL(versionURL), false);
						}
					});
				}
			});
		},

		/**
		 * If a product already exists, then disable selections of product versions
		 * @param {Context} ctx
		 * @param {FormData} fd
		 * @return {boolean}
		 */
		_canAggregate(ctx, fd) {
			const productUrl = ctx.getNodeParent()?.$URL;
			this.existingProducts = this.existingProducts || csi.hashArray(fd.getAggregatedNodes(), xml.ATTR_PARENT, Boolean);
			return !this.existingProducts[productUrl];
		}

	});
});
